import { useTranslation } from "react-i18next";
import { ProgressBar } from "src/ui/shared/ProgressBar";
import { filesize } from "src/ui/utils/filesize";
import { makeStyles } from "tss-react/mui";

import { Theme, useTheme } from "@mui/material";
import { showErrorToast } from "@shared/toasts/Toasts";

import { useDeleteFileMutation } from "../api/index";
import { useUploadContext } from "../context/UploadContext";

const useStyles = makeStyles()((theme: Theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        border: "1px solid " + theme.palette.emteria.border.primary,
        borderRadius: 10,
        padding: theme.spacing(2, 5),
        marginBottom: theme.spacing(2),
        boxSizing: "border-box",
    },
    fileContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
    },
    fileName: {
        fontSize: 12,
        fontWeight: "bold",
    },
    fileSize: {
        fontSize: 12,
    },
    pointer: {
        cursor: "pointer",
    },
}));

export const UploadProgressBar = () => {
    const { t } = useTranslation(["sidepanels"]);
    const { classes } = useStyles();
    const theme = useTheme();
    const { uploadProgress, cancelUpload, uploadedFileIds, setUploadedFileIds, selectedFiles } = useUploadContext();
    const fileNameTitle = selectedFiles.map((file) => file.name).join(", ");
    const fileSizeTitle = selectedFiles.map((file) => filesize(file.size, "N/A")).join(", ");

    const [deleteFile] = useDeleteFileMutation();

    const handleCancelBtn = async () => {
        cancelUpload();

        if (!selectedFiles.length) {
            showErrorToast(t("sidepanels:groupPanel.toast.noFilesToDelete"));
            return;
        }

        try {
            const deletePromises = uploadedFileIds.map((id) => deleteFile(id));
            await Promise.all(deletePromises);
            setUploadedFileIds([]);
        } catch {
            showErrorToast(t("sidepanels:groupPanel.toast.deleteFileError"));
        }
    };
    return (
        <div className={classes.container}>
            <div className={classes.fileContainer}>
                <div>
                    <div className={classes.fileName}>{fileNameTitle}</div>
                    <div className={classes.fileSize}>{fileSizeTitle}</div>
                </div>
                <div className={classes.pointer}>
                    <i className="fa fa-times" aria-hidden="true" onClick={handleCancelBtn}></i>
                </div>
            </div>
            <ProgressBar progress={uploadProgress} color={theme.palette.emteria.primary} />
        </div>
    );
};
